import { render, staticRenderFns } from "./RegisterHospital.vue?vue&type=template&id=1ce286c2&scoped=true"
import script from "./RegisterHospital.vue?vue&type=script&lang=js"
export * from "./RegisterHospital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce286c2",
  null
  
)

export default component.exports